const LoadingIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="12" stroke="#EFF2F9" strokeWidth="3" />
      <circle
        cx="16"
        cy="16"
        fill="none"
        stroke="#BEC4D5"
        strokeWidth="3"
        r="12"
        strokeDasharray="32 16"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="0.7s"
          values="0 16 16;360 16 16"
          keyTimes="0;1"
        ></animateTransform>
      </circle>
    </svg>
  )
}

export default LoadingIcon
